
export function loadMultipageForm(send:Function){
    const progress = (value) => {
        document.getElementsByClassName('progress-bar')[0].style.width = `${value}%`;
     }
     
        const step = document.getElementsByClassName('step');
        const prevBtn = document.getElementById('prev-btn');
        const nextBtn = document.getElementById('next-btn');
        const submitBtn = document.getElementById('submit-btn');
        const form = document.getElementById('course-setup-form');
        const preloader = document.getElementById('preloader-wrapper');
        const bodyElement = document.querySelector('body');
        const succcessDiv = document.getElementById('success');
    
        const previousSteps = []
      
        form.onsubmit = () => { return false }
     
        let current_step = 0;
        const stepCount = document.querySelectorAll(".step").length - 1
        console.log(stepCount)
        step[current_step].classList.add('d-block');
        if(current_step == 0){
           prevBtn.classList.add('d-none');
           submitBtn.classList.add('d-none');
           nextBtn.classList.add('d-inline-block');
        }
     
        function findValueToAdd(step, current_step:number):number{
            const current = $(step[current_step])
    
            if (step[current_step].classList.contains('decision')){
                const checked = $(current).find("input:checked")
    
                console.log(checked)
                
                if (checked.length === 0){
                    return 1; // none checked -> assume going only one step    
                }
    
                return checked.val() == 1 ? Number(current.attr('data-yes')) : Number(current.attr('data-no'))
            }
    
            return 1; // if it is not a decision field
        }
    
        function switchTextIfNecessary(step, current_step:number, addition:number){
            const current = $(step[current_step])
    
            const target = current.attr('data-switch')
            if (target !== undefined){
                if (addition == 1){ // normal way
                    $(target).html(current.attr('data-normal'))
                } else {
                    $(target).html(current.attr('data-jump'))
                }
            }
        }
    
        function checkStep(step, current_step){
            const current = $(step[current_step])
    
            let fields = current.attr('data-fields')
            let checks = current.attr('data-checks')
    
            if (fields === undefined || checks === undefined){
                return true
            }
    
            fields = JSON.parse(fields.replace("'", '"'))
            checks = JSON.parse(checks.replace("'", '"'))
    
            if (fields.length !== checks.length){
                return true
            }
    
            let fine = true
            fields.forEach((field, ind) => {
                const fieldIsFine = checkField(field, checks[ind]) // The checks for one field can be multiple
                if (!fieldIsFine){
                    fine = false;
                }
            })
    
            return fine
        }
    
        function checkField(field:string, checks:Array<string>){
            const value = $(field).val()
            let fine = true
            checks.forEach((check) => {
                if (check == 'exists'){
                    const checkPassed = (value !== '' && value !== undefined) ? true : false
                    if (!checkPassed){
                        fine = false
                    }
                }
            })
            if (!fine){
                $(field).addClass('is-invalid')
            }
            return fine;
        }
     
        function cleanStep(step, current_step){
            const current = $(step[current_step])
    
            console.log($(current).find("input[type='radio']"))
            // clean inputs
            $(current).find("input[type='radio']").prop('checked', false)
            // Clean checkboxes
            $(current).find("input[type='checkbox']").prop('checked', false)
            // Clean texts
            $(current).find("input[type='email']").val('')
            $(current).find("input[type='text']").val('')
        }
    
        nextBtn.addEventListener('click', () => {
    
            if (!checkStep(step, current_step)){
                return false;
            }
        
           const addition = findValueToAdd(step, current_step)
    
            previousSteps.push(current_step)
    
           const previous_step = current_step 
           current_step += addition;
    
           switchTextIfNecessary(step, current_step, addition);
    
           if(( current_step > 0) && (current_step <= stepCount)){
             prevBtn.classList.remove('d-none');
             prevBtn.classList.add('d-inline-block');
             step[current_step].classList.remove('d-none');
             step[current_step].classList.add('d-block');
             step[previous_step].classList.remove('d-block');
             step[previous_step].classList.add('d-none');
             if (current_step == stepCount){
               submitBtn.classList.remove('d-none');
               submitBtn.classList.add('d-inline-block');
               nextBtn.classList.remove('d-inline-block');
               nextBtn.classList.add('d-none');
             }
           } else {
             if(current_step > stepCount){
                 form.onsubmit = () => { return true }
             }
           }
         progress((100 / stepCount) * current_step);
         });
     
     
        prevBtn.addEventListener('click', () => {
            
            cleanStep(step, current_step) // cleans the current step while going back
    
          if(current_step > 0){
    
            const previous_step = current_step
            current_step = previousSteps[previousSteps.length - 1]
            // current_step = previousSteps.at(-1)
            
            if (previousSteps.length > 0){ // only one item
                previousSteps.pop()
            }
    
            //  current_step--;
            //  let previous_step = current_step + 1; 
             prevBtn.classList.add('d-none');
             prevBtn.classList.add('d-inline-block');
             step[current_step].classList.remove('d-none');
             step[current_step].classList.add('d-block')
             step[previous_step].classList.remove('d-block');
             step[previous_step].classList.add('d-none');
             if(current_step < stepCount){
                submitBtn.classList.remove('d-inline-block');
                submitBtn.classList.add('d-none');
                nextBtn.classList.remove('d-none');
                nextBtn.classList.add('d-inline-block');
                prevBtn.classList.remove('d-none');
                prevBtn.classList.add('d-inline-block');
             } 
          }
     
          if(current_step == 0){
             prevBtn.classList.remove('d-inline-block');
             prevBtn.classList.add('d-none');
          }
         progress((100 / stepCount) * current_step);
        });
     
     
     submitBtn.addEventListener('click', function() {
         // preloader.classList.add('d-block');
     
        //  const timer = ms => new Promise(res => setTimeout(res, ms));
        const data = $(form).serializeArray()

        const request = send(data, $(this))
            
            
        request.done((result) => {
            // bodyElement.classList.add('loaded');
        }).then(() => {
            step[stepCount].classList.remove('d-block');
            step[stepCount].classList.add('d-none');
            prevBtn.classList.remove('d-inline-block');
            prevBtn.classList.add('d-none');
            submitBtn.classList.remove('d-inline-block');
            submitBtn.classList.add('d-none');
            succcessDiv.classList.remove('d-none');
            succcessDiv.classList.add('d-block');
        })
           
     });
}